import React from "react";
import { Button, Menu, Dropdown } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useSaleOrderModel } from "../saleOrderModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
import { DownOutlined } from "@ant-design/icons";
import { formatNum } from "@/utils/utils";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"

export const DataBox = () => {
    const { selectedRowKeys, selectedRow, descTotal,rowsDescTotal, invalidateData, setOfferPrint, setSalePrint, listExport, detailsExport, onTransfer } = useSaleOrderModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });

            return;
        }
        if (selectedRow.status === DictCodeEnmu.SALE_ORDER_CHANGE) {
            globalPrompt("message", { text: Locale["The document has been cancelled and cannot be edited."], type: "warning" });
            return;
        }
        if (selectedRow.status === DictCodeEnmu.SALE_ORDER_TRANSFER) {
            globalPrompt("message", { text: "该单据已转接,不可以在编辑", type: "warning" });
            return;
        }
        let saleSoEditKey = "2-6-2";
        let isFindNav = findNav(saleSoEditKey);
        if (!isFindNav) {
            addNav(saleSoEditKey, { id: selectedRow.saleOrderCode as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: Locale["Jump to the detail page of Sales doc."],
                type: "warning",
                text: Locale["The detail page of Sales doc has not been saved. Do you still want to jump?"],
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(saleSoEditKey, { id: selectedRow.saleOrderCode as string, mode: "edit" });
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data to view."], type: "warning" });
            return;
        }
        let supplierEditKey = "2-6-3";
        replaceNav(
            selectedNavId,
            "2-6-3",
            { id: selectedRow.saleOrderCode as string, mode: "look", },
            true
        );
    }
    const cancellation = async () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data for cancellation."], type: "warning" });
            return;
        }
        if (selectedRow.status === DictCodeEnmu.SALE_ORDER_CHANGE) {
            globalPrompt("message", { text: '已作废的单据不能再次作废', type: "warning" });
            return;
        }
        if (selectedRow.status === DictCodeEnmu.SALE_ORDER_TRANSFER) {
            globalPrompt("message", { text: '已转接的单据不可作废', type: "warning" });
            return;
        }
        let val: string = ""
        globalPrompt("modal", {
            title: Locale["Cancel the Sales doc."],
            type: "error",
            text: `销售订单【${selectedRow.saleOrderCode}】是否确认作废?`,
            okText: Locale["Yes No"],
            onOk: () => {
                let obj = {
                    id: selectedRow.id,
                    saleOrderCode: selectedRow.saleOrderCode
                    // val
                }
                invalidateData(obj)
            },
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
    }

    const onQuotationPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        setOfferPrint(true)
    }

    const onSaleBillPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        setSalePrint(true)
    }

    // 转销售单
    const onTrunSaleSo = () =>{
        let { saleOrderCode } = selectedRow
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        if (selectedRow.status === DictCodeEnmu.SALE_ORDER_CHANGE) {
            globalPrompt("message", { text: "该单据已作废不可以转接", type: "warning" });
            return;
        }
        if (selectedRow.status === DictCodeEnmu.SALE_ORDER_TRANSFER) {
            globalPrompt("message", { text: '单据已转接不可再次转接', type: "warning" });
            return;
        }
        globalPrompt("modal", {
            title: Locale["Sales order transfer sales doc."],
            type: "warning",
            text: `销售订单【${saleOrderCode}】是否确认转接为销售单?`,
            okText: Locale["Yes No"],
            onOk: async () => { await saveTrunSaleSo(saleOrderCode as string)},
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
    }

    const saveTrunSaleSo = async (saleOrderCode: string) => {
        let retData = await onTransfer(saleOrderCode as string)
        if(retData){
            replaceNav(selectedNavId, '2-3')
            globalPrompt("message", { text: Locale["Transfer sales doc. successful"], type: "success" })
        }
    }

    const MenuExport = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={listExport}>{Locale["List export"]}</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={detailsExport}>{Locale["Details export"]}</span>
                </Menu.Item>
            </Menu>
        )
    }
    const action = <>
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["SalesOrderAdd"]}
            onClick={() => addNav("2-6-1", { id: "", mode: "add" })}
            name={Locale["Add"]}
        />
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["SalesOrderEdit"]}
            onClick={onEdit}
            name={Locale["Edit"]}
        />
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["SalesOrderView"]}
            onClick={onLook}
            name={Locale["View"]}
        />
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["SalesOrderTransfer"]}
            onClick={onTrunSaleSo}
            name={Locale["Transfer Sales"]}
        />
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["SalesOrderCancel"]}
            onClick={cancellation}
            name={Locale["Cancel"]}
        />
        <Dropdown overlay={MenuExport}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
            >{Locale["export"]}<DownOutlined /></Button>
        </Dropdown>
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["SalesOrderPrint"]}
            onClick={onQuotationPrint}
            name={Locale["Quotation Print"]}
        />
        {/* <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["MaterialSalesPrint"]}
            onClick={onSaleBillPrint}
            name={Locale["SaleBill Print"]}
        /> */}
    </>;

    const desc: IDescription[] = [
        {
            label: Locale["Order Number"],
            value: selectedRowKeys.length === 0 ? descTotal.totalNum : (rowsDescTotal.totalNum),
            color: DescriptionColorEnum.red
        },
        {
            label: Locale["Order Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.totalAmount : formatNum(rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        },
        {
            label: Locale["Discount Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.discountTotalAmount : formatNum(rowsDescTotal.discountTotalAmount),
            color: DescriptionColorEnum.red
        },
        {
            label: Locale["Receivable Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.receivedAmount : formatNum(rowsDescTotal.receivedAmount),
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <YhBox title={<></>} descriptions={desc} action={action} >
            <DataTable />
        </YhBox>
    )
}